import { useNavigate } from '@remix-run/react';
import { ArrowLeftIcon } from '@radix-ui/react-icons';

function PlayerError({ message }: { message?: string }) {
  const navigate = useNavigate();

  return (
    <div className="h-screen bg-zinc-800">
      <div className="p-5">
        <button onClick={() => navigate(-1)}>
          <ArrowLeftIcon color="white" width={30} height={30} />
        </button>
      </div>
      <div className="mt-48 flex items-center justify-center">
        <p className="text-white">
          {message ? message : 'An error occurred. Please try again later.'}
        </p>
      </div>
    </div>
  );
}

export default PlayerError;
